var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import ParagraphComponent from "./ParagraphComponent";
import ImagesComponent from "./ImagesComponent";
import ImageParagraphComponent from "./ImageParagraphComponent";
import VideoComponent from "./VideoComponent";
import PatentComponent from "./PatentComponent";
import ListComponent from "./ListComponent";
import TableComponent from "./TableComponent";
import FilesComponent from "./FilesComponent";
export var PageComponentType;
(function (PageComponentType) {
    PageComponentType["Paragraph"] = "Paragraph";
    PageComponentType["Images"] = "Images";
    PageComponentType["ImageParagraph"] = "ImageParagraph";
    PageComponentType["Patent"] = "Patent";
    PageComponentType["Video"] = "Video";
    PageComponentType["List"] = "List";
    PageComponentType["Table"] = "Table";
    PageComponentType["Files"] = "Files";
})(PageComponentType || (PageComponentType = {}));
var PageComponent = /** @class */ (function (_super) {
    __extends(PageComponent, _super);
    function PageComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageComponent.prototype.render = function () {
        var type = this.props.type;
        switch (type) {
            case PageComponentType.Paragraph:
                return React.createElement(ParagraphComponent, __assign({}, this.props));
            case PageComponentType.Images:
                return React.createElement(ImagesComponent, __assign({}, this.props));
            case PageComponentType.ImageParagraph:
                return React.createElement(ImageParagraphComponent, __assign({}, this.props));
            case PageComponentType.Video:
                return React.createElement(VideoComponent, __assign({}, this.props));
            case PageComponentType.Patent:
                return React.createElement(PatentComponent, __assign({}, this.props));
            case PageComponentType.List:
                return React.createElement(ListComponent, __assign({}, this.props));
            case PageComponentType.Table:
                return React.createElement(TableComponent, __assign({}, this.props));
            case PageComponentType.Files:
                return React.createElement(FilesComponent, __assign({}, this.props));
            default:
                return null;
        }
    };
    return PageComponent;
}(React.Component));
export default PageComponent;
